export const AMPERSAND = '&'
export const ASSIGNMENT = '='
export const AT_SIGN = '@'
export const BACKWARD_SLASH = '\\'
export const CLOSE_BRACKET = ']'
export const CLOSE_CURLY_BRACE = '}'
export const CLOSE_PARENTHESIS = ')'
export const COLON = ':'
export const COMMA = ','
export const DIVIDE = '/'
export const DOLLAR_SIGN = '$'
export const DOT = '.'
export const EQUALITY = '=='
export const GREATER_THAN = '>'
export const GREATER_THAN_EQUAL = '>='
export const INEQUALITY = '!='
export const INFINITY = '∞'
export const LESS_THAN = '<'
export const LESS_THAN_EQUAL = '<='
export const LOGICAL_AND = '&&'
export const LOGICAL_NOT = '!'
export const LOGICAL_OR = '||'
export const MODULUS = '%'
export const MULTIPLY = '*'
export const OPEN_BRACKET = '['
export const OPEN_CURLY_BRACE = '{'
export const OPEN_PARENTHESIS = '('
export const QUESTION_MARK = '?'
export const SEMICOLON = ';'
export const TILDE = '~'
export const UNARY_MINUS = '-'
export const UNARY_PLUS = '+'
